// Limite décimale, identique à celle du seul bucket partenaire-medias.
export const VIDEO_MAX_BYTES = 500_000_000;
export const VIDEO_STORAGE_BUCKET = "partenaire-medias";
export const VIDEO_MIME_TYPES = ["video/mp4", "video/quicktime", "video/webm"] as const;

// La durée dépend de la ligne documentaire, jamais du point d'entrée.
export function partenaireDocumentUrlDuration(doc: { storageBucket: string }) {
  return doc.storageBucket === VIDEO_STORAGE_BUCKET ? 4 * 3600 : 3600;
}

const EXTENSION_MIME: Record<string, string> = {
  mp4: "video/mp4", mov: "video/quicktime", webm: "video/webm",
};
export function isPartenaireVideo(name: string, mime: string) {
  return mime.toLowerCase().startsWith("video/") ||
    ["mp4", "mov", "webm", "avi", "mkv", "m4v", "wmv"].includes(name.split(".").pop()?.toLowerCase() || "");
}
export function validatePartenaireVideo(name: string, mime: string, size: number) {
  const extension = name.split(".").pop()?.toLowerCase() || "";
  const effectiveMime = mime.trim().toLowerCase() || EXTENSION_MIME[extension];
  if (!EXTENSION_MIME[extension] || !VIDEO_MIME_TYPES.includes(effectiveMime as typeof VIDEO_MIME_TYPES[number])) {
    throw new Error("Format vidéo non autorisé — utilisez MP4, MOV ou WebM avec un type MIME vidéo valide.");
  }
  if (!Number.isSafeInteger(size) || size <= 0) throw new Error("La vidéo est vide ou sa taille est invalide.");
  if (size > VIDEO_MAX_BYTES) {
    throw new Error(`Vidéo trop lourde : ${Math.round(size / 1_000_000)} Mo — maximum ${VIDEO_MAX_BYTES / 1_000_000} Mo`);
  }
  return { extension, mimeType: effectiveMime };
}

// Inspection de l'en-tête, sans transcodage ni téléchargement du fichier entier.
export function detectVideoHeader(bytes: Uint8Array): string | null {
  const ascii = (start: number, end: number) => String.fromCharCode(...bytes.slice(start, end));
  if (bytes.length >= 4 && bytes[0] === 0x1a && bytes[1] === 0x45 && bytes[2] === 0xdf && bytes[3] === 0xa3) return "video/webm";
  if (bytes.length < 12) return null;
  if (ascii(4, 8) === "ftyp") return ascii(8, 12) === "qt  " ? "video/quicktime" : "video/mp4";
  if (["moov", "mdat", "wide", "free"].includes(ascii(4, 8))) return "video/quicktime";
  return null;
}
